var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"icon",class:_vm.modifiers},'component',_vm.attributes,false),_vm.$listeners),[_vm._t("default",function(){return [(_vm.svg)?_c(_vm.svg,{tag:"component",staticClass:"icon__svg"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }